import { AttributeDataType, IAttributeMetadata, IAttributeOption, IServiceAttribute, IServiceMetadata } from "../models"
import { useEffect, useState } from "react"

import { ReadOnlyAttribute } from "./ReadOnlyAttribute"

export const ServiceAttributeWrapper = ({ metadata, attribute, value, entity, entityId, relativePath, documentsOnly }: {
    metadata: IServiceMetadata,
    attribute: IServiceAttribute,
    value?: string,
    entity?: string,
    entityId?: string,
    relativePath: string | undefined,
    documentsOnly: boolean,
}) => {
    const [attributeMetadata, setAttributeMetadata] = useState<IAttributeMetadata>()
    const [options, setOptions] = useState<IAttributeOption[]>([])
    const [checklistId, setChecklistId] = useState<string>()

    useEffect(() => {
        const options = metadata.attributeOptions.filter(p => p.attributeId === attribute.attributeId)
        setOptions(options)

        const attributeMetadata = metadata.attributes.find(p => p.id === attribute.attributeId)
        setAttributeMetadata(attributeMetadata)

        if (attributeMetadata?.datatype === AttributeDataType.DocumentChecklist) {
            setChecklistId(attributeMetadata.documentChecklist)
        }

        // eslint-disable-next-line
    }, [])

    return <>
        <ReadOnlyAttribute
            attribute={attribute}
            value={value}
            entity={entity}
            entityId={entityId}
            checklistId={checklistId}
            relativePath={relativePath}
            options={options}
            documentsOnly={documentsOnly}
            metadata={attributeMetadata} />
    </>
}
